export default __webpack_public_path__ + "static/media/2017-2.42831ab8.webp";